module.exports = __webpack_public_path__ + "static/thunderplains-f0b6d35e62bf25c1c58f7ec4bd4d2b6c.jpeg";